<template>
	<v-dialog max-width="496"
			  v-model="dialog">

		<!--Activator-->
		<template v-slot:activator="{on, attrs}">

			<div v-on="on">

				<v-hover v-slot="{hover}">
					<app-icon class="newCopy-container"
							  :color="hover ? 'white' : ''"
							  icon="newCopy"
							  title="Copy"/>
				</v-hover>

			</div>

		</template>

		<!--Content-->
		<v-card>

			<!--Toolbar-->
			<v-toolbar class="appGradient">
				<app-text color="white" size="medium">Copy</app-text>
				<v-spacer/>
				<close-icon @click.native="dialog = false" class="pa-2"/>
			</v-toolbar>

			<!--Body-->
			<div class="pa-4">

				<!--Information-->
				<app-text>
					You are about to duplicate this document.
					The new copy will be renamed <strong>{{ `! COPY OF - ${selectedItem[itemName]}` }}</strong>
					<br>
					<br>
					<strong>Are you sure you want to do this?</strong>
				</app-text>

				<!--Action Buttons-->
				<div class="d-flex justify-space-between mt-4">

					<!--No-->
					<app-btn @click.native="dialog = false"
							 color="grey"
							 icon="close"
							 label="No"/>

					<!--Yes-->
					<app-btn @click.native="handleYes"
							 color="green"
							 icon="check"
							 label="Yes"/>

				</div>

			</div>

		</v-card>

	</v-dialog>
</template>

<script>
export default {

	name: "NewCopyIcon",

	props: ['itemName', 'selectedItem'],

	data: () => ({
		dialog: false,
	}),

	methods: {

		handleYes() {
			const t = this

			t.$emit('emitCopyItem', t.$props.selectedItem)
		},

	}

}
</script>

<style scoped>
.newCopy-container {
	transition: 0.3s;
	padding: 8px;
}

.newCopy-container:hover {
	background: var(--v-green-base);
	border-radius: 50%;
	padding: 8px;
	transition: 0.3s;
}
</style>
